import TextField from './TextField';

const MuiOverrides = {
  components: {
    ...TextField,
  },
};
export default MuiOverrides;
